var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{class:_vm.cellClasses},[_vm._t('cell(' + _vm.column.key + ')',function(){return [_vm._t("cell",function(){return [_vm._v(_vm._s(_vm.item[_vm.column.key])+" ")]},{"column":_vm.column,"item":_vm.item,"value":_vm.item[_vm.column.key]})]},{"column":_vm.column,"item":_vm.item,"value":_vm.item[_vm.column.key]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }